<template>
  <PageLayout>
    <div class="page__info">
      <div class="container">
        <div class="page__info-box">
          <h1 class="page__title mb-m">
            Руководство по&nbsp;оформлению заявки на&nbsp;Всероссийский конкурс
            кружков
          </h1>
          <div class="page__subtitle-box">
            <img
              src="@/assets/images/kd-logo-white-big.svg"
              alt="Логотип кружкового движения"
              class="mb-xl page__kd-logo"
            />
            <p class="page__kd-info-text">
              Конкурс является одним из&nbsp;ключевых событий в&nbsp;серии
              мероприятий
              <a
                href="https://team.kruzhok.org"
                target="_blank"
                rel="noopener noreferrer"
                title="Кружковое движение"
                class="link-text-white"
                >Кружкового&nbsp;движения</a
              >
              (КД)&nbsp;&mdash; всероссийского сообщества энтузиастов
              научно-технического творчества.
            </p>
          </div>
          <BaseButton
            v-if="!requests.length"
            tag="a"
            :href="user ? '#tracks' : '#participate'"
            class="button mt-xl"
            >Принять участие</BaseButton
          >
        </div>
      </div>
    </div>

    <!--      Как принять участие-->
    <div class="page__participate page__colored" id="participate">
      <div class="container">
        <ParticipationTerms :user="user" @handleLoginClick="handleLoginClick" />
      </div>
    </div>

    <!--      Треки-->
    <div class="page__tracks page__colored pt0">
      <div class="container">
        <ContestTracks
          :user="user"
          :is-organizations="!!organizations.length"
          @handleRegister="handleEventReg"
        />
      </div>
    </div>

    <!--      Определения конкурса-->
    <div class="page__definitions page__colored pt0">
      <div class="container">
        <ContestDefinitions />
      </div>
    </div>
  </PageLayout>
</template>

<script>
import ParticipationTerms from "@/components/ParticipationTerms";
import ContestTracks from "@/components/ContestTracks";
import ContestDefinitions from "@/components/ContestDefinitions";
import { request } from "@/plugins/request";
import {
  CONTEST_EVENTS,
  ORGANIZATION_FIELD_NAME,
  PLATFORM_FIELD_NAME,
} from "@/constants";
import PageLayout from "@/components/PageLayout.vue";
export default {
  name: "MainPage",
  components: {
    ContestDefinitions,
    ContestTracks,
    ParticipationTerms,
    PageLayout,
  },
  computed: {
    requests() {
      return this.$store.state.requestPreparing.requests;
    },
    organizations() {
      return this.$store.state.requestPreparing.organizations;
    },
    user() {
      return this.$store.state.user.user;
    },
    eventsFields() {
      return this.$store.state.requestPreparing.eventsFields;
    },
    selectedOrganization() {
      return this.$store.state.requestPreparing.selectedOrganization;
    },
    selectedPlatform() {
      return this.$store.state.requestPreparing.selectedPlatform;
    },
  },
  mounted() {
    let externalScript = document.createElement("script");
    externalScript.setAttribute(
      "src",
      `${process.env.VUE_APP_TALENT_HOST}/talent-iframe-client.js`
    );
    document.head.appendChild(externalScript);

    /**
     * Меняю урл в iframe client иначе он будет открывать
     * модалку которая смотрит на prod
     */
    const url = process.env.VUE_APP_TALENT_HOST + "/registration";
    if (window.talentApp) {
      window.talentApp.config.iframeURL = url;
    } else {
      window.talentAppInit = (app) => {
        app.config.iframeURL = url;
      };
    }
  },
  methods: {
    async handleLoginClick(e) {
      if (process.env.NODE_ENV !== "development") {
        return;
      }
      e.preventDefault();
      const [email, password] = prompt(
        "Укажите email и пароль через разделитель ;",
        "email@email.mail;password"
      ).split(";");
      const fd = new FormData();
      fd.append("username", email);
      fd.append("password", password);
      fd.append("grant_type", "password");
      try {
        const { data } = await request({
          method: "POST",
          url: "/oauth/issue-token/",
          data: fd,
        });
        if (data?.access_token) {
          this.$store.commit("user/SET_TOKEN", data.access_token);
          await this.$store.dispatch("user/getMe");
        }
        if (this.organizations.length) {
          await this.getUserRequests();
        }
        this.$store.dispatch("requestPreparing/getEventsFields");
      } catch (error) {
        this.showErrorModal({
          content: "Не удалось авторизоваться",
          message: JSON.stringify(error?.response?.data),
        });
      }
    },
    async getUserRequests() {
      try {
        await Promise.all(
          Object.values(CONTEST_EVENTS).map((id) => {
            return this.$store.dispatch("requestPreparing/getRequest", {
              id,
              userId: this.user.id,
            });
          })
        );
        if (this.requests.length > 1) {
          this.showRequestWarningModal({
            requests: this.requests,
            confirmHandler: (request) => {
              this.requests = [request];
            },
          });
        }
      } catch (error) {
        this.$store.commit("requestPreparing/SET_REQUESTS", []);
        this.showErrorModal({
          content: "Не удалось получить заявки",
          message: JSON.stringify(error?.response?.data),
        });
      }
    },
    handleEventReg(id) {
      if (
        !this.eventsFields[id]?.[ORGANIZATION_FIELD_NAME] ||
        !this.eventsFields[id]?.[PLATFORM_FIELD_NAME]
      ) {
        this.showErrorModal({
          title: "Подача заявки",
          content:
            "Мы не смогли получить необходимые данные для регистрации на данное мероприятие. Пожалуйста, обновите страницу или повторите попытку позже.",
          status: "ошибка",
        });
        return;
      }
      const e_files = {
        [this.eventsFields[id][ORGANIZATION_FIELD_NAME]]:
          this.selectedOrganization.id,
        [this.eventsFields[id][PLATFORM_FIELD_NAME]]: this.selectedPlatform.id,
        eventId: id,
      };

      const queryString = encodeURIComponent(JSON.stringify(e_files));
      // eslint-disable-next-line
      talentApp &&
        // eslint-disable-next-line
        talentApp.open(id, {
          params: {
            e_fields: queryString,
          },
        });
      window.addEventListener("message", this.receiveMessage, false);
    },
    receiveMessage(event) {
      if (
        event.data.e_type === "talent" &&
        event.data.e_action === "reg-complete"
      ) {
        this.getUserRequests();
      }
    },
  },
};
</script>

<style scoped lang="less">
.page {
  &__kd-logo {
    width: 200px;
    height: 53px;
  }
  &__title {
    font-size: @font-size-h1;
    line-height: @line-height-h1;
    color: #fff;
    max-width: 720px;
    text-align: center;
    font-weight: 700;
    text-transform: uppercase;
  }

  &__subtitle-box {
    font-size: @font-size-l;
    line-height: @line-height-h1;
    color: #fff;
    max-width: 720px;
    text-align: center;
  }

  &__info {
    padding: 80px 0 100px;
    width: 100%;
    background-image: url("./../assets/images/wave.jpg");
    background-color: #3a1974;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    min-height: 520px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &-box {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &__kd-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 80px 0;
    text-align: center;

    &-text {
      max-width: 720px;
    }
  }

  &__colored {
    padding: 80px 0 100px;
    background-color: @background-blue;
  }

  &__transparent {
    padding: 80px 0 100px;
  }

  &__participants {
    &-title {
      font-size: @font-size-h2;
      line-height: @line-height-h2;
      max-width: 720px;
      text-align: center;
      font-weight: 700;
      margin: 0 auto;
    }

    &-box {
      display: flex;
      gap: 20px;
      justify-content: space-between;
    }

    &-item {
      border: 1px solid @blue-color;
      border-radius: 4px;
      max-width: 400px;
      width: 100%;
      padding: 30px;

      &-title {
        font-size: @font-size-l;
        line-height: @line-height-l;
        color: @primary-color;
        margin-bottom: @margin-s;
      }
    }
    &-icon {
      color: @primary-color;
    }
    &-buttons {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: @margin-l;
      gap: 10px;
    }
  }

  &__partners {
    &-title {
      font-size: @font-size-h2;
      line-height: @line-height-h2;
      max-width: 720px;
      text-align: center;
      font-weight: 700;
      margin: 0 auto;
    }

    &-text {
      text-align: center;
      margin: 0 auto;
      max-width: 720px;
    }

    &-button {
      margin-top: @margin-l;
      display: flex;
      justify-content: center;
    }
  }
  @media (max-width: @screen-xs) {
    &__title {
      font-size: @font-size-h4;
      line-height: @line-height-h4;
    }
    &__subtitle {
      font-size: @base-font-size;
      line-height: @base-line-height;
    }
    &__kd-info {
      font-size: @font-size-s;
      line-height: @line-height-s;
    }
    &__participants {
      &-title {
        font-size: @font-size-h4;
        line-height: @line-height-h4;
      }
    }
    &__partners {
      &-title {
        font-size: @font-size-h4;
        line-height: @line-height-h4;
      }
    }
    &__colored {
      padding: 60px 0 80px;
    }

    &__transparent {
      padding: 60px 0 80px;
    }
  }

  @media (max-width: @screen-xs-max) {
    &__participants {
      &-buttons {
        flex-direction: column;
      }
      &-box {
        flex-direction: column;
      }
      &-item {
        max-width: none;
        padding: 20px;
      }
    }
    .button {
      width: 100%;
      display: block;
    }
  }
}
</style>
